import { EXPERIENCE_DOMAIN_CONFIG, EXPERIENCE_HOST_DOMAINS } from '../constants';

type GaConfig = {
  [key in EXPERIENCE_DOMAIN_CONFIG]: {
    tracker: string;
    active: boolean;
  };
};

/** google analytics configurations */
const config: GaConfig = {
  [EXPERIENCE_HOST_DOMAINS.localhost]: {
    tracker: 'UA-138525213-2',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.mumbai]: {
    tracker: 'UA-138525213-2',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.euDev]: {
    tracker: 'UA-138525213-2',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.qa1]: {
    tracker: 'UA-100502788-4',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.qa2]: {
    tracker: 'UA-100502788-4',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.qa3]: {
    tracker: '',
    active: false,
  },
  [EXPERIENCE_HOST_DOMAINS.qa4]: {
    tracker: '',
    active: false,
  },
  [EXPERIENCE_HOST_DOMAINS.uatAM]: {
    tracker: '',
    active: false,
  },
  [EXPERIENCE_HOST_DOMAINS.uatEU]: {
    tracker: 'UA-100502788-4',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.uatUS]: {
    tracker: '',
    active: false,
  },
  [EXPERIENCE_HOST_DOMAINS.stagingUS]: {
    tracker: 'UA-100502788-4',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.stagingEU]: {
    tracker: 'UA-100502788-4',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.au]: {
    tracker: 'UA-100502788-2',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.eu]: {
    tracker: 'UA-100502788-2',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.us]: {
    tracker: 'UA-100502788-2',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.cn]: {
    tracker: '',
    active: false,
  },
  [EXPERIENCE_HOST_DOMAINS.au1]: {
    tracker: 'UA-100502788-2',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.eu1]: {
    tracker: 'UA-100502788-2',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.us1]: {
    tracker: 'UA-100502788-2',
    active: true,
  },
  [EXPERIENCE_HOST_DOMAINS.cn1]: {
    tracker: '',
    active: false,
  },
};

export default config;
